export default __webpack_public_path__ + "static/media/PinkFrame05.2a8bd48b.png";